import { concat } from "ramda";
import { compose } from "redux";
import { IAction } from "../../../models/Action";
import {
  IBREntitlementsItem,
  IBRRequestItem,
  IEntitlementItem,
} from "../../../models/Entitlements";
import { immutableSet } from "../../../utils/immutable";
import { actionTypes } from "./actions";
import emptyState from "./emptyState";
import { IDENTITY_SYSTEM } from "../../../module/constants";

const ACTION_HANDLERS = {
  [actionTypes.FETCH_ENTITLEMENT_REQUEST]: (state: any, action: IAction) =>
    immutableSet(["entitlement", ["loader"]], true, state),
  [actionTypes.FETCH_ENTITLEMENT_REQUEST_SUCCESS]: (
    state: any,
    action: IAction
  ) => {
    const brList: IBRRequestItem[] =
      action.payload.businessRoles && action.payload.businessRoles;
    const mappedBrList: any[] = brList.map((item: IBRRequestItem) => {
      return {
        application_id: item.id,
        application_name: item.name,
        application_description: item.description,
        entitlement_id: item.id,
        entitlement_name: "",
        entitlement_description: "",
        identitySystemId: "",
        editable: true,
        isBR: true,
        entitlements: [],
      };
    });
    const entitlementList: IEntitlementItem[] =
      action.payload.entitlements &&
      action.payload.entitlements.length > 0 &&
      action.payload.entitlements
        .map((item: IEntitlementItem) => {
          return {
            ...item,
            editable: true,
            identitySystemId:
              IDENTITY_SYSTEM[
                item.identity_system_id as keyof typeof IDENTITY_SYSTEM
              ],
          };
        })
        .filter((entitlement: any) => entitlement.showOnFrontend);

    const payloadTemp: IEntitlementItem[] = concat(
      mappedBrList ? mappedBrList : [],
      entitlementList ? entitlementList : []
    );
    return compose(
      immutableSet(["entitlement", ["loader"]], false),
      immutableSet(["entitlement", ["list"]], payloadTemp)
    )(state);
  },
  [actionTypes.FETCH_ENTITLEMENT_REQUEST_FAILURE]: (
    state: any,
    action: IAction
  ) => immutableSet(["entitlement", ["loader"]], false, state),

  [actionTypes.SET_BR_ENTITLEMENT_IN_REFERENCE]: (state: any, action: any) =>
    immutableSet(["entitlement", ["brEntitlements"]], action.payload, state),

  [actionTypes.SELECT_DETAIL_ENTITLEMENT]: (state: any, action: IAction) =>
    immutableSet(["entitlementDetail", ["detail"]], action.payload, state),

  [actionTypes.FETCH_BENEFICIARY_REQUEST]: (state: any, action: IAction) =>
    immutableSet(["entitlementDetail", ["loader"]], true, state),
  [actionTypes.FETCH_BENEFICIARY_REQUEST_SUCCESS]: (
    state: any,
    action: IAction
  ) => {
    const tempList: any = [];
    action.payload &&
      action.payload.length > 0 &&
      action.payload.forEach((item: any) => {
        const tempObj = {
          ...item,
          identitySystemId:
            IDENTITY_SYSTEM[
              item.identitySystemId as keyof typeof IDENTITY_SYSTEM
            ],
          beneficiary_id: item.id,
        };
        delete tempObj["id"];
        tempList.push(tempObj);
      });
    return compose(
      immutableSet(["entitlementDetail", ["loader"]], false),
      immutableSet(["entitlementDetail", ["beneficiaryList"]], tempList)
    )(state);
  },
  [actionTypes.FETCH_BENEFICIARY_REQUEST_FAILURE]: (
    state: any,
    action: IAction
  ) => immutableSet(["entitlementDetail", "loader"], false, state),

  [actionTypes.GET_BR_ENTITLEMENT_IN_REFERENCE]: (
    state: any,
    action: IAction
  ) =>
    compose(
      immutableSet(["brEntitlements", "loader"], true),
      immutableSet(["brEntitlements", "list"], [])
    )(state),
  [actionTypes.GET_BR_ENTITLEMENT_IN_REFERENCE_SUCCESS]: (
    state: any,
    action: IAction
  ) => {
    const mappedResponse: any[] = [];
    if (action.payload && action.payload.length > 0) {
      action.payload.forEach((item: any) => {
        const temp = {
          uniqueId: item.entitlement_id,
          identitySystemId:
            IDENTITY_SYSTEM[
              item.identity_system_id as keyof typeof IDENTITY_SYSTEM
            ],
          application_name: item.application_name,
          application_description: item.application_description,
          entitlement_name: item.entitlement_name,
          entitlement_description: item.entitlement_description,
        };
        mappedResponse.push(temp);
      });
    }
    return compose(
      immutableSet(["brEntitlements", "loader"], false),
      immutableSet(["brEntitlements", "list"], mappedResponse)
    )(state);
  },
  [actionTypes.GET_BR_ENTITLEMENT_IN_REFERENCE_FAILURE]: (
    state: any,
    action: IAction
  ) =>
    compose(
      immutableSet(["brEntitlements", "loader"], false),
      immutableSet(["brEntitlements", "list"], [])
    )(state),
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    action.payload.location.pathname === "/welcome"
  ) {
    return emptyState;
  }
  const handler: any = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
